import { AutogenModelTariffLineItem, AutogenRowTariffLineItem } from "./autogen/AutogenModelTariffLineItem";

export class ModelTariffLineItem extends AutogenModelTariffLineItem<RowTariffLineItem> {
	constructor() {
		super(RowTariffLineItem);
	}
}

export class RowTariffLineItem extends AutogenRowTariffLineItem {
}